export const jenniferViewSample = {
    'customMessage': 'Jennifer Cpu Error Custom Message 99!!',
    'domainId': 1000,
    'domainName': 'Data Server',
    'errorType': 'Metrics EVENT',
    'eventLevel': 'NORMAL',
    'instanceData': {
        'hostName': 'SEOUL-A-DEV-LIGHTSABER-INTEGRATION-WAS01',
        'instanceId': 1,
        'ipAddress': '10.251.33.11',
        'platform': 'JAVA',
    },
    'message': '99 > value',
    'metricsName': 'proc_cpu',
    'oType': 'SYSTEM',
    'serviceName': 'AlertNow',
    'time': 1558516256002,
    'value': 0.5025125741958618
};

export const jenniferSample = {
    'customMessage': 'Jennifer Cpu Error Custom Message 99!!',
    'domainId': 1000,
    'domainName': 'Data Server',
    'errorType': 'Metrics EVENT',
    'eventLevel': 'NORMAL',
    'instanceData.hostName' : 'SEOUL-A-DEV-LIGHTSABER-INTEGRATION-WAS01',
    'instanceData.instanceId' : 1,
    'instanceData.ipAddress' : '10.251.33.11',
    'instanceData.platform' : 'JAVA',
    'message': '99 > value',
    'metricsName': 'proc_cpu',
    'oType': 'SYSTEM',
    'serviceName': 'AlertNow',
    'time': 1558516256002,
    'value': 0.5025125741958618
};



// WEBPACK FOOTER //
// ./src/app/views/main/integration/cstmSmry.sample/jennifer.ts